import { useCallback } from 'react'

import { setToken } from '@/app/module/auth/helpers'
import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_SAVE_PASSWORD_SERVER } from '@/app/module/user/definitions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export type ChangePasswordValues = {
  currentPassword: string
  newPassword: string
  newPasswordConfirm: string
}

type SaveUserPasswordResponse = {
  access?: string
  validUntil?: string
}

export const useChangePassword = () => {
  const dispatch = useAppDispatch()
  const [saveUser, res] = esApi.endpoints.saveUser.useMutation()

  const changePassword = useCallback(
    async (values: ChangePasswordValues) => {
      try {
        const response = (await saveUser({
          body: {
            currentPassword: values.currentPassword,
            newPassword: values.newPassword,
            newPasswordAgain: values.newPasswordConfirm,
          },
        }).unwrap()) as SaveUserPasswordResponse

        dispatch(
          createNotification({
            'reset-password': {
              type: 'success',
              message: 'New password successfully set.',
            },
          }),
        )

        if (response.access && response.validUntil) {
          setToken(response.access, response.validUntil)
        }

        return true
      } catch (error) {
        const errorMessage = getErrorMessage(error, ERROR_SAVE_PASSWORD_SERVER)
        dispatch(
          createNotification({
            'reset-password': {
              type: 'error',
              message: errorMessage,
            },
          }),
        )
        return false
      }
    },
    [dispatch, saveUser],
  )

  return [changePassword, res] as const
}
